// @import "~@govbr-ds/core/src/components/table-header-cell/table-header-cell";

:host {
  display: table-cell;
  --horizontal-align: left;
}

.br-table-header-cell {
  color: var(--color);
  font-size: var(--font-size-scale-base);
  font-weight: var(--font-weight-medium);
  padding: var(--table-row-size) var(--table-padding);
  text-align: var(--horizontal-align);

  &.vertical-border {
    border-left: 1px solid #ccc;
  }
}
